import { render } from "./CompanyReputationCard.vue?vue&type=template&id=b2027738&scoped=true"
import script from "./CompanyReputationCard.vue?vue&type=script&lang=js"
export * from "./CompanyReputationCard.vue?vue&type=script&lang=js"

import "./CompanyReputationCard.vue?vue&type=style&index=0&id=b2027738&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2027738"]])

export default __exports__